import { ElectedInfo } from "../../../../src/components/electeds/elected-info.js";
import Preston from "../../../../content/people/dean-preston/preston.js";
import * as React from 'react';
export default {
  ElectedInfo,
  Preston,
  React
};